import { PaymentBrand } from '../types';
const PaymentBrandToNameMap = {
    [PaymentBrand.AMEX]: { shortName: 'AMEX', longName: 'AMEX' },
    [PaymentBrand.VISA]: { shortName: 'Visa', longName: 'Visa' },
    [PaymentBrand.MASTERCARD]: {
        shortName: 'Mastercard',
        longName: 'Mastercard',
    },
    [PaymentBrand.DISCOVER]: { shortName: 'Discover', longName: 'Discover' },
    [PaymentBrand.JCB]: { shortName: 'JCB', longName: 'JCB' },
    [PaymentBrand.DINERS]: { shortName: 'Diners', longName: 'Diners' },
    [PaymentBrand.CARTE_BLUE]: {
        shortName: 'CARTE BLEUE',
        longName: 'CARTE BLEUE',
    },
    [PaymentBrand.ELO]: { shortName: 'Elo', longName: 'Elo' },
    [PaymentBrand.SOLO]: { shortName: 'Solo', longName: 'Solo' },
    [PaymentBrand.UNIONPAY]: { shortName: 'UnionPay', longName: 'UnionPay' },
    [PaymentBrand.SEPA_DIRECT_DEBIT]: {
        shortName: 'SEPA',
        longName: 'SEPA Direct Debit',
        localeOverride: {
            fr: {
                shortName: 'SEPA',
                longName: 'Prélèvement SEPA',
            },
            pt: {
                shortName: 'SEPA',
                longName: 'Débito Direto SEPA',
            },
            de: {
                shortName: 'SEPA',
                longName: 'SEPA-Lastschrift',
            },
            es: {
                shortName: 'SEPA',
                longName: 'Adeudo directo SEPA',
            },
            vi: {
                shortName: 'SEPA',
                longName: 'Ghi nợ trực tiếp SEPA',
            },
        },
    },
    [PaymentBrand.SEPA_OFFLINE]: {
        shortName: 'SEPA',
        longName: 'SEPA Direct Debit',
        localeOverride: {
            fr: {
                shortName: 'SEPA',
                longName: 'Prélèvement SEPA',
            },
            pt: {
                shortName: 'SEPA',
                longName: 'Débito Direto SEPA',
            },
            de: {
                shortName: 'SEPA',
                longName: 'SEPA-Lastschrift',
            },
            es: {
                shortName: 'SEPA',
                longName: 'Adeudo directo SEPA',
            },
            vi: {
                shortName: 'SEPA',
                longName: 'Ghi nợ trực tiếp SEPA',
            },
        },
    },
    [PaymentBrand.MP_OXXO]: { shortName: 'OXXO', longName: 'OXXO' },
    [PaymentBrand.MP_BANAMEX]: {
        shortName: `Banamex`,
        longName: `Banamex`,
        localeOverride: {
            pt: {
                shortName: 'Citibanamex',
                longName: 'Citibanamex',
            },
            es: {
                shortName: 'Citibanamex',
                longName: 'Citibanamex',
            },
        },
    },
    [PaymentBrand.MP_BANCOMER]: {
        shortName: `Bancomer`,
        longName: `Bancomer`,
        localeOverride: {
            pt: {
                shortName: 'BBVA Bancomer',
                longName: 'BBVA Bancomer',
            },
            es: {
                shortName: 'BBVA Bancomer',
                longName: 'BBVA Bancomer',
            },
        },
    },
    [PaymentBrand.MP_SERFIN]: { shortName: `Serfin`, longName: `Serfin` },
    [PaymentBrand.BOLETO]: {
        shortName: `Boleto Bancário`,
        longName: `Boleto Bancário`,
    },
    [PaymentBrand.BANK_TRANSFER]: {
        shortName: `Netbanking`,
        longName: `Netbanking`,
    },
    [PaymentBrand.MERCADO_PAGO_RECURRING]: {
        shortName: `Mercado Pago`,
        longName: `Mercado Pago`,
    },
    [PaymentBrand.CREDITS_PREPAID_CARD]: {
        shortName: `Credits Prepaid Card`,
        longName: `Credits Prepaid Card`,
    },
    [PaymentBrand.REG_DOT_RU]: { shortName: `Reg.ru`, longName: `Reg.ru` },
    [PaymentBrand.MAESTRO]: { shortName: `MAESTRO`, longName: `MAESTRO` },
    [PaymentBrand.SOFORT]: { shortName: `Sofort`, longName: `Sofort` },
    [PaymentBrand.PAYPAL]: { shortName: `PayPal`, longName: `PayPal` },
    [PaymentBrand.ENROUTE]: { shortName: `Enroute`, longName: `Enroute` },
    [PaymentBrand.YANDEX]: { shortName: `Yandex`, longName: `Yandex` },
    [PaymentBrand.BANCARD]: { shortName: `Bancard`, longName: `Bancard` },
    [PaymentBrand.UNKNOWN]: { shortName: `Unknown`, longName: `Unknown` },
};
export const paymentBrandName = (paymentBrand, locale) => {
    const brandObject = PaymentBrandToNameMap[paymentBrand];
    if (brandObject) {
        const { localeOverride, longName, shortName } = brandObject;
        if (localeOverride && localeOverride[locale]) {
            return localeOverride[locale];
        }
        return { longName, shortName };
    }
    return { longName: '', shortName: '' };
};
//# sourceMappingURL=paymentBrandName.js.map